import * as React from 'react';

import * as styles from './MortgageWidgetPromoDiscount.css';
import icon from './assets/promo-house.svg';
import { trackMortgageWidgetAnchorClick } from './tracking';

const redirectPath =
  '/ipoteka-main?cian_source=cian&cian_medium=trap&cian_campaign=price_block&cian_content=link_under_price&cian_term=card';

export const MortgageWidgetPromoDiscount = () => {
  const handleAnchorClick = () => {
    trackMortgageWidgetAnchorClick();
  };

  return (
    <div className={styles['container']}>
      <a
        href={redirectPath}
        className={styles['anchor-next']}
        onClick={handleAnchorClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className={styles['anchor-icon']}>
          <img src={icon} />
        </div>
        Ипотека со скидкой 3,8%
      </a>
    </div>
  );
};
